
import { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { portfolioEvents } from '../../mocks/portfolioEvents';
import EventNavbar from './components/EventNavbar';
import EventHero from './components/EventHero';
import EventOverview from './components/EventOverview';
import EventChallenge from './components/EventChallenge';
import EventGallery from './components/EventGallery';
import EventBreakdown from './components/EventBreakdown';
import EventTestimonial from './components/EventTestimonial';
import RelatedEvents from './components/RelatedEvents';
import EventFooter from './components/EventFooter';

export default function EventDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const [scrolled, setScrolled] = useState(false);

  const event = portfolioEvents.find((e) => e.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!event) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-white">
      <EventNavbar scrolled={scrolled} eventTitle={event.title} />
      <EventHero
        heroImage={event.heroImage}
        title={event.title}
        category={event.category}
        location={event.location}
        date={event.date}
        guests={event.guests}
      />
      <EventOverview
        description={event.description}
        client={event.client}
        duration={event.duration}
        budget={event.budget}
        guests={event.guests}
        location={event.location}
      />
      <EventChallenge challenge={event.challenge} solution={event.solution} />
      <EventGallery
        gallery={event.gallery}
        title={event.title}
        before={event.before}
        after={event.after}
      />
      <EventBreakdown services={event.services} equipment={event.equipment} />
      <EventTestimonial
        quote={event.testimonial.quote}
        author={event.testimonial.author}
        role={event.testimonial.role}
        category={event.category}
      />
      <RelatedEvents currentSlug={event.slug} currentCategory={event.category} />
      <EventFooter />
    </div>
  );
}
